var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "app-container" },
      [
        _c("h3", { staticClass: "header-title" }, [_vm._v("労働通知書一覧")]),
        _vm._v(" "),
        _c("LaborNoticeFilter"),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { margin: "32px" } },
          [
            _c("label", [
              _vm._v(
                _vm._s(_vm.currentPage + 1) + " / " + _vm._s(_vm.maxPage + 1)
              ),
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "button-first",
                attrs: { type: "info", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.goTopPage()
                  },
                },
              },
              [_vm._v("先頭ページ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "button-first",
                attrs: { type: "info", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.goPrePage()
                  },
                },
              },
              [_vm._v("前ページ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "button-first",
                attrs: { type: "info", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.goNextPage()
                  },
                },
              },
              [_vm._v("次ページ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "button-first",
                attrs: { type: "info", plain: "" },
                on: {
                  click: function ($event) {
                    return _vm.goLastPage()
                  },
                },
              },
              [_vm._v("最終ページ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-row",
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.clients_labor_notice, stripe: "", fit: "" },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "タイトル", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.client_reading_flag == true
                            ? _c("div", [
                                _c("span", { staticStyle: { color: "#f00" } }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(scope.row.title) +
                                      "\n              "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.client_reading_flag == false
                            ? _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(scope.row.title) +
                                      "\n              "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "公開日時", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.client_reading_flag == true
                            ? _c("div", [
                                scope.row.client_reading_flag == true
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "#f00" } },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.displayDateTime(
                                                scope.row.release_date,
                                                "YYYY年MM月DD日 HH:mm"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.client_reading_flag == false
                            ? _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.displayDateTime(
                                          scope.row.release_date,
                                          "YYYY年MM月DD日 HH:mm"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  staticClass: "buttons",
                  attrs: { align: "center", "min-width": "75" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.client_reading_flag == true
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        "background-color": "#f00",
                                        color: "#fff",
                                      },
                                      attrs: { type: "info" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goToDetail(scope.row.id)
                                        },
                                      },
                                    },
                                    [_vm._v("労働通知書")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.client_reading_flag == false
                            ? _c("div", [
                                _c(
                                  "span",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "info", plain: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.goToDetail(scope.row.id)
                                          },
                                        },
                                      },
                                      [_vm._v("労働通知書")]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { margin: "32px" } },
      [
        _c("label", [
          _vm._v(_vm._s(_vm.currentPage + 1) + " / " + _vm._s(_vm.maxPage + 1)),
        ]),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticClass: "button-first",
            attrs: { type: "info", plain: "" },
            on: {
              click: function ($event) {
                return _vm.goTopPage()
              },
            },
          },
          [_vm._v("先頭ページ")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticClass: "button-first",
            attrs: { type: "info", plain: "" },
            on: {
              click: function ($event) {
                return _vm.goPrePage()
              },
            },
          },
          [_vm._v("前ページ")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticClass: "button-first",
            attrs: { type: "info", plain: "" },
            on: {
              click: function ($event) {
                return _vm.goNextPage()
              },
            },
          },
          [_vm._v("次ページ")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticClass: "button-first",
            attrs: { type: "info", plain: "" },
            on: {
              click: function ($event) {
                return _vm.goLastPage()
              },
            },
          },
          [_vm._v("最終ページ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }